import type { EventInterestProfile, EventInterests } from '@conference/shared';
import apiClient from './apiClient';

export const eventInterestService = {
  getMine: (eventId: string) => apiClient.get<EventInterestProfile>(`/events/${eventId}/me/interests`),
  saveMine: (eventId: string, body: EventInterests) => apiClient.put<EventInterests>(`/events/${eventId}/me/interests`, body),
};
